var _ref2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBin = function SvgBin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "#041F47",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 16.0176C10 16.5676 9.55 17.0176 9 17.0176C8.45 17.0176 8 16.5676 8 16.0176V12.0176C8 11.4676 8.45 11.0176 9 11.0176C9.55 11.0176 10 11.4676 10 12.0176V16.0176ZM16 16.0176C16 16.5676 15.55 17.0176 15 17.0176C14.45 17.0176 14 16.5676 14 16.0176V12.0176C14 11.4676 14.45 11.0176 15 11.0176C15.55 11.0176 16 11.4676 16 12.0176V16.0176ZM18 19.0176C18 19.5686 17.552 20.0176 17 20.0176H7C6.448 20.0176 6 19.5686 6 19.0176V8.01758H18V19.0176ZM10 4.34558C10 4.19058 10.214 4.01758 10.5 4.01758H13.5C13.786 4.01758 14 4.19058 14 4.34558V6.01758H10V4.34558ZM21 6.01758H20H16V4.34558C16 3.06158 14.879 2.01758 13.5 2.01758H10.5C9.121 2.01758 8 3.06158 8 4.34558V6.01758H4H3C2.45 6.01758 2 6.46758 2 7.01758C2 7.56758 2.45 8.01758 3 8.01758H4V19.0176C4 20.6716 5.346 22.0176 7 22.0176H17C18.654 22.0176 20 20.6716 20 19.0176V8.01758H21C21.55 8.01758 22 7.56758 22 7.01758C22 6.46758 21.55 6.01758 21 6.01758Z"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgBin, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/bin.64a3b01e.svg";
export { ForwardRef as ReactComponent };